import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const handler = ( $ ) => {
	const $video = $( '.video-autoplay__media video' );

	if ( ! $video.length ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const videoElement = $video.get( 0 );

	if ( ! videoElement ) {
		return;
	}

	ScrollTrigger.create( {
		trigger: '.video-autoplay',
		start: 'top 80%',
		end: 'bottom 20%',
		onEnter: () => {
			$video.prop( 'muted', true );
			videoElement.play().catch( () => {
				console.log( 'Video playback failed' );
			} );
		},
		onLeave: () => {
			videoElement.pause();
		},
		onEnterBack: () => {
			videoElement.play().catch( () => {
				console.log( 'Video playback failed' );
			} );
		},
		onLeaveBack: () => {
			videoElement.pause();
		},
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
